var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'svv-auth-valid': _vm.isUserValid }},[(
      _vm.apiAccessValid &&
        _vm.widgetSettings.widget_view_mode &&
        _vm.widgetSettings.widget_view_mode === 'plain'
    )?_c('PlainListViewMode'):_vm._e(),(
      _vm.apiAccessValid &&
        _vm.widgetSettings.widget_view_mode &&
        _vm.widgetSettings.widget_view_mode === 'modal'
    )?_c('ModalDialogViewMode'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }